import React from 'react';
import { Button, LoadingButton, ModalHeader, ModalBody, ModalFooter, Typography, } from '@one-thd/sui-atomic-components';
export const DefaultAddressModal = ({ hideModal, onSave, address, isLoading, }) => {
    const { addressLine1, addressLine2, city, state, zipCode } = address;
    return (React.createElement(React.Fragment, null,
        React.createElement(ModalHeader, { onClose: hideModal }, "Confirm Your New Default Address"),
        React.createElement(ModalBody, null,
            React.createElement(Typography, { variant: "body-base", weight: "bold" }, "New Default Address"),
            React.createElement(Typography, { "data-qm-mask": "", variant: "body-base" }, addressLine1),
            React.createElement(Typography, { "data-qm-mask": "", variant: "body-base" }, addressLine2),
            React.createElement(Typography, { "data-qm-mask": "" },
                city,
                ", ",
                state,
                " ",
                zipCode)),
        React.createElement(ModalFooter, { position: "end" },
            React.createElement("div", { className: "sui-flex sui-gap-4 sm:sui-gap-4 sui-flex-col-reverse sui-w-full sm:sui-flex-row sm:sui-w-auto" },
                React.createElement(Button, { variant: "secondary", onClick: hideModal }, "Cancel"),
                React.createElement(LoadingButton, { variant: "primary", onClick: onSave, loading: isLoading, "data-testid": "confirm-new-def-address-btn" }, "Set New Default Address")))));
};
DefaultAddressModal.displayName = 'DefaultAddressModal';
